import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Hosts from "../../../Hosts"
import { reqGET } from '../../../Utils';
import { getTokenInfo } from '../../../UseToken';


export default function DetalhesEntidade() {
  const { id } = useParams(); 
  const [entidade, setEntidade] = useState(null);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 

  useEffect(() => {
    async function fetchEntidade() {
      try {
        const response = await reqGET(Hosts.SIMCore_API + '/entities/' + getTokenInfo().companycode + '/' + id); // retorno os detalhes da entidade selecionada pelo utilizador diretamente

        if (!response || response.status !== 200) {
          throw new Error(`erro ao ir buscar a entidade: ${response.statusText || 'Sem resposta'}`);
        }
  
        const result = response.data; 
        if (Array.isArray(result) && result.length > 0) {
          setEntidade(result[0]); 
        } else {
          console.log("result é um array vazio")
          setEntidade(null);
        }

        setLoading(false); 

      } catch (error) {
        setError('Erro ao buscar dados da entidade.');
        setLoading(false);
      }
    }

    fetchEntidade();
  }, [id]); 

  useEffect(() => {
  }, [entidade])
  
  if (error) {
    return <div>{error}</div>;
  }

  if (loading) {
    return <div> A carregar informações da entidade...</div>;
  }

  return (
    <div>
        <div className={`dash-cards header`}>
              <h4> Detalhes da Entidade: </h4>
            </div>
        {entidade ? (
          <div className={`dash-cards body`}>
              <div className="container">
                <div className="row">
                  <div className="mb-5 mb-xl-10">
                    <div className="card">
                      <div className="card-header border-0"> 
                        <div className="card-title m-0">
                          <div className="fw-bolder m-0">

                            <div className="row border border-dark border-1 py-2 mb-2" >
                              <div className= "d-inline-flex"> Nome:  <div className= "text-secondary fw-normal">  &nbsp; {entidade.info?.name}</div> </div>
                            </div>

                            <div className="row border border-dark border-1 py-2 mb-2"> 
                            <div className= "d-inline-flex"> Morada:  <div className= "text-secondary fw-normal">  &nbsp; {entidade.addresses[0].address_detail}, {entidade.addresses[0].city || ""} </div></div>
                            </div>

                            <div className="row border border-dark border-1 py-2 mb-2">
                                  <div className='col-md-6 d-inline-flex'> Código-Postal: <div className= "text-secondary fw-normal"> &nbsp;  {entidade.addresses[0].postal_code || ""}</div> </div>
                                  <div className='col-md-6 d-inline-flex'> Localidade: <div className= "text-secondary fw-normal" >&nbsp; {entidade.addresses[0].localidade || ""} </div> </div>
                            </div>
                            
                              <div className="row border border-dark border-1 py-2 mb-2">
                                <div className='col-md-6 d-inline-flex'>Data de Abertura Ficha: <div className= "text-secondary fw-normal">&nbsp; {entidade.info?.dataAberturaFicha || ""}</div> </div>
                                <div  className='col-md-6 d-inline-flex'>Telefone: <div className= "text-secondary fw-normal" >&nbsp;{entidade.contacts[0].mobile_phone || ""}</div> </div>
                              </div>

                            <table className="table table-bordered text-center my-5">
                                  <thead>
                                      <tr className="table-success">
                                          <th scope="col">SSL</th>
                                          <th scope="col">Email</th>
                                          <th scope="col">Site</th>
                                          <th scope="col">Obs</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr>
                                          <td>{entidade.info?.ssl || ""}</td>
                                          <td>{entidade.contacts[0]?.email || ""}</td>
                                          <td>{entidade.info?.site || ""}</td>
                                          <td>{entidade.info?.obs || ""}</td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        ) : (
          <p>Nenhuma informação disponível para esta entidade.</p>
        )}
        {/* <pre>{JSON.stringify(entidade, null, 4)}</pre> */}
    </div>
  );
}